import script from "./RentOwnCar.vue?vue&type=script&setup=true&lang=js"
export * from "./RentOwnCar.vue?vue&type=script&setup=true&lang=js"

import "./RentOwnCar.vue?vue&type=style&index=0&id=6aaed1aa&lang=css"

const __exports__ = script;

export default __exports__